import { $authHost } from '.'
import {
	ActivityResponse,
	ProfileUpdatePayload,
	Session,
	SessionItem,
	User,
	UserRole
} from '../helpers/types/user'

export const fetchUsers = async () => {
	const { data } = await $authHost.get('/user/')
	return data as User[]
}

export const getProfile = async () => {
	const { data } = await $authHost.get('/user/me')
	return data as User
}

export const updateProfile = async (payload: ProfileUpdatePayload) => {
	const { data } = await $authHost.patch('/user/me', payload)
	return data as User
}

export const uploadAvatar = async (file: File) => {
	const formData = new FormData()
	formData.append('avatar', file)
	const { data } = await $authHost.post('/user/me/avatar', formData, {
		headers: { 'Content-Type': 'multipart/form-data' }
	})
	return data as User
}

export const deleteAvatar = async () => {
	const { data } = await $authHost.delete('/user/me/avatar')
	return data as User
}

export const getActivity = async (page = 1, limit = 10) => {
	const { data } = await $authHost.get('/user/me/activity', {
		params: { page, limit }
	})
	return data as ActivityResponse
}

export const getSessions = async (): Promise<Session[]> => {
	const { data } = await $authHost.get('/user/me/sessions')
	// backend may return plain array or { data: Session[] } envelope
	return Array.isArray(data) ? data : (data?.data ?? [])
}

export const terminateSession = async (sessionId: string) => {
	await $authHost.delete(`/user/me/sessions/${encodeURIComponent(sessionId)}`)
}

export const fetchAllSessions = async (): Promise<Session[]> => {
	const { data } = await $authHost.get('/auth/sessions')
	return Array.isArray(data) ? data : (data?.data ?? [])
}

export const updateUserRole = async (userId: string, role: UserRole) => {
	await $authHost.patch(`/user/${encodeURIComponent(userId)}/role`, { role })
}

// keep old SessionItem export alias alive for existing callers
export type { SessionItem }
